module.exports = __webpack_public_path__ + "static/media/vision-02.80ad39ca.png";